/**
 * Project : workspace
 * File    : BusinessSaleHomeScreen.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.business.sale

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Modifier
import com.friendly.shared.component.layout.VerticalGrid
import com.parmartechnologies.business.feature.business.viewModel.BusinessViewModel
import com.parmartechnologies.communication.core.handler.AuthHandler
import com.parmartechnologies.communication.core.viewModel.AuthViewModel
import com.parmartechnologies.business.feature.employee.viewModel.EmployeeViewModel
import com.parmartechnologies.core.navigation.NavigationParam
import common.constants.BusinessMenuConfig
import component.navigation.TopNavBar
import navigation.AppNavigator
import navigation.route.business.BusinessNavRoute
import org.jetbrains.compose.ui.tooling.preview.Preview
import presentation.screens.business.business_list.component.BusinessCard
import presentation.screens.business.home.component.NoBusinessSelectedCard
import presentation.screens.business.home.component.NotLoggedInCard
import presentation.screens.business.home.component.headerCard
import presentation.screens.business.home.component.menuCard

/**
 * Represents the business sale home screen class.
 */

class BusinessSaleHomeScreen {
    @Preview
    @Composable
    fun content() {
        val localization = AuthHandler.shared().repository.localization.collectAsState()
        val allMenu = BusinessMenuConfig().getPointOfSaleMenu(localization.value)
        val viewModel = BusinessViewModel()
        val myBusiness = viewModel.myBusiness.collectAsState()
        val allBusiness = viewModel.allBusiness.collectAsState()
        val authViewModel = AuthViewModel()
        val authUser = authViewModel.authUser.collectAsState()
        val params = AppNavigator.shared().getNavigationParam()
        LaunchedEffect(key1 = Unit) {
            AuthHandler.shared().checkIfLoggedIn()
            viewModel.loadBusiness()
            EmployeeViewModel().retrieve()
        }

        Column {
            TopNavBar(
                "", NavigationParam(),
                showNotification = true,
                onBackPress = { AppNavigator.shared().goBack()}
            )
            LazyColumn(
                modifier = Modifier
                    .fillMaxSize()
            ) {
                item {
                    if (authUser.value._id.isNotEmpty()) {
                        if (myBusiness.value._id.isNotEmpty()) {
                            BusinessCard(myBusiness.value) {
                                AppNavigator.shared().navigate(BusinessNavRoute.SELECT_SELF_BUSINESS)
                            }
                            headerCard(menu = allMenu[0])
                            VerticalGrid(
                                columns = 2
                            )
                            {
                                allMenu[1].sub_menu.forEach { menu ->
                                    menuCard(menu) { screen ->
                                        params.business = myBusiness.value
                                        params.selectedBusiness = myBusiness.value
                                        AppNavigator.shared().navigate(screen ?: "",params)
                                    }
                                }
                            }
                        } else {
                            NoBusinessSelectedCard(allBusiness.value)
                        }
                    } else {
                        NotLoggedInCard()
                    }
                }
            }
        }
    }
}